/**
 * CONTROLLER_COMMAND_TYPE
 * -----------------------
 *
 * Commands are controller intents.
 *
 * They may originate from:
 * - React/UI
 * - adapter callbacks promoted to controller actions
 * - internal orchestration logic
 *
 * Unlike ControllerEvent, commands are not facts.
 * They request work to be performed by the controller/adapters.
 */
export const CONTROLLER_COMMAND_TYPE = {
    // Signaling transport / session
    CONNECT_SIGNALING: "CONNECT_SIGNALING",
    DISCONNECT_SIGNALING: "DISCONNECT_SIGNALING",
    SEND_PING: "SEND_PING",
    SEND_ACK: "SEND_ACK",
    // Call lifecycle
    CREATE_CALL: "CREATE_CALL",
    ACCEPT_CALL: "ACCEPT_CALL",
    REJECT_CALL: "REJECT_CALL",
    END_CALL: "END_CALL",
    // Media
    ACQUIRE_LOCAL_MEDIA: "ACQUIRE_LOCAL_MEDIA",
    STOP_LOCAL_MEDIA: "STOP_LOCAL_MEDIA",
    TOGGLE_LOCAL_AUDIO: "TOGGLE_LOCAL_AUDIO",
    TOGGLE_LOCAL_VIDEO: "TOGGLE_LOCAL_VIDEO",
    SELECT_AUDIO_INPUT_DEVICE: "SELECT_AUDIO_INPUT_DEVICE",
    SELECT_VIDEO_INPUT_DEVICE: "SELECT_VIDEO_INPUT_DEVICE",
    SELECT_AUDIO_OUTPUT_DEVICE: "SELECT_AUDIO_OUTPUT_DEVICE",
    REFRESH_MEDIA_DEVICES: "REFRESH_MEDIA_DEVICES",
    // RTC / signaling payload exchange
    CREATE_AND_SEND_OFFER: "CREATE_AND_SEND_OFFER",
    APPLY_REMOTE_OFFER_AND_SEND_ANSWER: "APPLY_REMOTE_OFFER_AND_SEND_ANSWER",
    APPLY_REMOTE_ANSWER: "APPLY_REMOTE_ANSWER",
    ADD_REMOTE_ICE_CANDIDATE: "ADD_REMOTE_ICE_CANDIDATE",
    SEND_LOCAL_ICE_CANDIDATE: "SEND_LOCAL_ICE_CANDIDATE",
    REPORT_PC_CONNECTION_STATE: "REPORT_PC_CONNECTION_STATE",
    // RTC lifecycle
    ENSURE_PEER_CONNECTION: "ENSURE_PEER_CONNECTION",
    CLOSE_PEER_CONNECTION: "CLOSE_PEER_CONNECTION",
};
